import * as React from 'react'
import { CollapseProps, default as MuiCollapse } from '@mui/material/Collapse'

export const Collapse = (props: CollapseProps) => {
  return <MuiCollapse timeout="auto" {...props} />
}

export default Collapse
